"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Powerpoint = void 0;
const ProdSysBase_1 = require("./ProdSysBase");
const Wopi_1 = require("./Wopi");
class Powerpoint extends ProdSysBase_1.ProdSysBase {
    static Open(instance, options) {
        return Wopi_1.Wopi.CallAction(instance, "PowerPoint", "edit", options);
    }
    static View(instance, options) {
        return Wopi_1.Wopi.CallAction(instance, "PowerPoint", "view", options);
    }
}
exports.Powerpoint = Powerpoint;
